import { TrackedLinkService, TrackedLink } from '@app/_components/tracked-link';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
    selector: 'app-tracked-link-form',
    templateUrl: './tracked-link.component.html',
    styleUrls: ['./tracked-link.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class TrackedLinkFormComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private trackedLinkService: TrackedLinkService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private clipboard: Clipboard,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		this.formTitle = data.title;
		this.trackedLink = data.trackedLink;
		this.trackingModes = trackedLinkService.trackingModes;
		this.sourceTypes = trackedLinkService.sourceTypes;
		this.statuses = trackedLinkService.statuses;
	}

	@Input() trackedLink: TrackedLink;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	trackedLinkId: number;
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: string;
	formTitle: string;

	trackingModes: any;
	sourceTypes: any;
	statuses: any;

	generatedTrackingUrl: string;

	validationMessages = {
		'destinationUrl': [
			{ type: 'required', message: 'Destination URL is required' }
		],
		'trackingMode': [
			{ type: 'required', message: 'Tracking mode is required' }
		],
		'sourceType': [
			{ type: 'required', message: 'Source type is required' }
		],
		'name': [],
		'sourceName': [],
		'description': [],
		'tags': [],
		'status': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		if (this.trackedLink) {
			this.trackedLinkId = this.trackedLink.trackedLinkId;
			this.generatedTrackingUrl = this.trackedLink.trackingUrl;
			this.form1.patchValue(this.trackedLink);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			trackedLinkId: [this.trackedLinkId],
			destinationUrl: ['', Validators.required],
			trackingMode: ['REDIRECT', Validators.required],
			sourceType: ['SOCIAL', Validators.required],
			status: ['ACTIVE'],
			name: [''],
			sourceName: [''],
			description: [''],
			tags: [''],
			sourceId: [null],
			mktgCampaignId: [null],
			expiresAt: [null],
		});
	}

	formAdd() {
		try {
			this.form1.markAllAsTouched();
			if (this.form1.invalid) { return; }

			this.formLoading = true;
			this.trackedLinkService.add(this.form1.value).subscribe(
				(res: any) => {
					this.trackedLink = res.data.trackedLink;
					this.generatedTrackingUrl = this.trackedLink.trackingUrl;
					this.messageService.add({ severity: 'success', summary: 'Created', detail: res.message });
					this.doAdd.emit(this.trackedLink);
				},
				(err: any) => {
					this.alertService.error(err);
				},
				() => { this.formLoading = false; }
			);
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		try {
			this.form1.markAllAsTouched();
			if (this.form1.invalid) { return; }

			this.formLoading = true;
			this.trackedLinkService.update(this.form1.value).subscribe(
				(res: any) => {
					this.trackedLink = res.data.trackedLink;
					this.generatedTrackingUrl = this.trackedLink.trackingUrl;
					this.messageService.add({ severity: 'success', summary: 'Updated', detail: res.message });
					this.doUpdate.emit(this.trackedLink);
				},
				(err: any) => {
					this.alertService.error(err);
				},
				() => { this.formLoading = false; }
			);
		} catch (error) {
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		this.confirmationService.confirm({
			message: 'Are you sure you want to archive link #' + this.trackedLinkId + '?',
			header: 'Confirm Archive',
			icon: 'pi pi-exclamation-triangle',
			accept: () => { this.formDelete(); },
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Archive canceled.', life: 3000 });
			}
		});
	}

	formDelete() {
		try {
			this.trackedLinkService.delete(this.trackedLink.trackedLinkId).subscribe(
				(res: any) => {
					this.messageService.add({ severity: 'success', summary: 'Archived', detail: res.message });
					this.doDelete.emit(this.trackedLink);
				},
				(err: any) => { this.alertService.error(err); },
				() => { this.formLoading = false; }
			);
		} catch (error) {
			this.alertService.error(error);
		}
	}

	copyTrackingUrl() {
		if (this.generatedTrackingUrl) {
			this.clipboard.copy(this.generatedTrackingUrl);
			this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Tracking URL copied to clipboard', life: 2000 });
		}
	}
}
